// Layouts
export const ID_LAYOUT_DEFAULT = 'default-layout'
export const ID_JSS_LAYOUT_DEFAULT = 'jss-default-layout'

// Pages
export const ID_PAGE_SETTINGS = 'home-settings'

// Components
export const ID_NAV_BAR = 'nav-bar'
export const ID_SUB_NAV = 'sub-nav'
